<template>
  <div
    class="relative sticky top-0 z-10 h-55px min-h-55px flex items-center justify-center bg-white"
  >
    <i
      class="icon-chevron-left absolute left-20px mr-auto cursor-pointer text-24px text-primary-80"
      @click="$router.push(previousRouter)"
    />
    <p class="title-14-h16-m text-primary-100">
      {{ title }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { type RouteLocationRaw } from 'vue-router'

defineProps<{
  previousRouter: RouteLocationRaw
  title: string
}>()
</script>
